/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DocumentoSpuntaDTO } from './documento-spunta-dto';


export interface DocumentoVersioneDettaglioDTO { 
    id?: string;
    numero?: number;
    stato?: DocumentoVersioneDettaglioDTOStatoEnum;
    titolo_it?: string;
    testo_it?: string;
    spunte?: Array<DocumentoSpuntaDTO>;
    pubblicato_at?: string;
    corretto_at?: string;
    updated_at?: string;
    version?: number;
}
export enum DocumentoVersioneDettaglioDTOStatoEnum {
    BOZZA = 'BOZZA',
    PUBBLICATA = 'PUBBLICATA'
};



